export interface BreadcrumbsStruct {
  name: string
  path: string
  current: boolean
  visited: boolean
}

export interface BreadcrumbsOptions {
  currentPath: string
}

const markAsVisited = (breadcrumbs: BreadcrumbsStruct[]) =>
  breadcrumbs.map((breadcrumb) => ({
    ...breadcrumb,
    visited: true,
  }))

export const useBreadcrumbs = (
  pathname: string,
  pathDisplayNameMap: Record<string, string>,
  options?: Partial<BreadcrumbsOptions>
) => {
  const crumbs = pathname.split('/')
  const crumbsToShow = crumbs.slice(1, crumbs.length)
  let breadcrumbs: BreadcrumbsStruct[] = []

  crumbsToShow.forEach((crumb, i) => {
    const name = pathDisplayNameMap[crumb]

    if (name) {
      const path = crumbs.slice(0, i + 2).join('/')
      const breadcrumbStruct = {
        name,
        path,
        visited: i < crumbsToShow.length - 1,
        current: i === crumbsToShow.length - 1,
      }

      if (options?.currentPath) {
        if (options?.currentPath === `/${crumb}`) {
          breadcrumbStruct.current = true
          breadcrumbStruct.visited = false
          breadcrumbs = markAsVisited(breadcrumbs)
        } else {
          breadcrumbStruct.current = false
          breadcrumbStruct.visited = false
        }
      }

      breadcrumbs.push(breadcrumbStruct)
    }
  })

  return breadcrumbs
}
